import { removeItem } from "../functions";

export default (state, action) => {
  let currentQueries = state.items ? state.items : {};
  let newQueries = { ...currentQueries };
  newQueries = removeItem(newQueries, currentQueries, false);

  return Object.assign({}, state, { items: newQueries });
};
